import React from 'react'

import FormHelperText from '@material-ui/core/FormHelperText'
import Typography from '@material-ui/core/Typography'
import { useTheme } from '@material-ui/core/styles'

import t from '../../../../translations'

// Lista identyfikatorów do aria-describedby i aria-labelledby bez pustych pozycji (undefined, gdy lista jest pusta).
export const describedBy = (...ids) => ids.filter(Boolean).join(' ') || undefined

// Gwiazdka przy pytaniach wymaganych (RANGE, NPS), objaśniona nad pytaniami w Poll.js. Ukryta przed czytnikami
// ekranu: wymagalność ogłasza aria-required na grupie ocen, a treść pytania zostaje czystą nazwą grupy.
export const RequiredMark = () => {
  const theme = useTheme()

  return (
    <span aria-hidden={'true'} style={{ color: theme.palette.primary.main }}>{' *'}</span>
  )
}

// Tekst błędów i podpowiedzi walidacji: 14 px zamiast domyślnych 12 px, kolor błędu z motywu (#CB092A, 5,81:1).
export const validationTextStyle = {
  fontSize: '0.875rem',
  lineHeight: 1.43,
}

const errorTextStyle = {
  ...validationTextStyle,
  textAlign: 'center',
}

// Błąd pod skalą ocen (skala jest wyśrodkowana, więc tekst też).
export const QuestionErrorText = ({ id, children }) => (
  <FormHelperText id={id} error={true} style={errorTextStyle}>
    {children}
  </FormHelperText>
)

// Odpowiedź przyjęta już przez serwer przy częściowym zapisie: pytanie jest zablokowane (disabled), a notka mówi
// dlaczego. Zwykły kolor tekstu (nie wyszarzony jak elementy wyłączone w MUI), żeby notka była czytelna.
export const SavedNote = ({ id, centered }) => (
  <Typography
    id={id}
    variant={'body2'}
    style={{ ...validationTextStyle, marginTop: 3, textAlign: centered ? 'center' : 'left' }}
  >
    {t.pollView.savedAnswer}
  </Typography>
)
